// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34wSW","rootNoMargin":"styles_rootNoMargin__1ANeZ"};